export default function InventoryReserveFromStock(){

    return(<>TODO</>)
}